import { Building2, Plus, Globe, Maximize2, Minimize2, Check } from "lucide-react";
import {
  DropdownMenuItem, DropdownMenuSeparator, DropdownMenuSub, DropdownMenuSubTrigger,
  DropdownMenuSubContent, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { LANGS, getLang, t } from "@/lib/i18n";
import { changeLang } from "@/components/LanguageSwitcher";

// Items hidden from the top bar on small screens: company, language, fullscreen
export function MobileMenuExtras({ isCompany, companies, activeCompanyId, setActiveCompany, onJoin, fs }) {
  return (
    <>
      <div className="md:hidden">
        {companies.length > 0 && (
          <>
            <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-muted-foreground">{isCompany ? t("Azienda") : t("Aziende")}</DropdownMenuLabel>
            {(isCompany ? companies.slice(0, 1) : companies).map((c) => (
              <DropdownMenuItem key={c.company_id} onClick={() => !isCompany && setActiveCompany(c.company_id)} data-testid={`menu-company-${c.company_id}`}>
                <Building2 className="h-4 w-4 mr-2" />
                <span className="truncate flex-1">{c.company_name}</span>
                {!isCompany && c.company_id === activeCompanyId && <Check className="h-4 w-4 ml-2 text-primary" />}
              </DropdownMenuItem>
            ))}
            {!isCompany && (
              <DropdownMenuItem onClick={onJoin} data-testid="menu-join-company">
                <Plus className="h-4 w-4 mr-2" /> {t("Collegati a un'azienda")}
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
          </>
        )}
      </div>
      <DropdownMenuSub>
        <DropdownMenuSubTrigger className="md:hidden" data-testid="menu-language">
          <Globe className="h-4 w-4 mr-2" /> {t("Lingua")}: {LANGS.find((l) => l.code === getLang())?.flag}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent>
          {LANGS.map((l) => (
            <DropdownMenuItem key={l.code} onClick={() => changeLang(l.code, true)} data-testid={`menu-language-${l.code}`}>
              {l.label} {l.code === getLang() && <Check className="h-4 w-4 ml-auto text-primary" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuSubContent>
      </DropdownMenuSub>
      {fs.supported && (
        <DropdownMenuItem className="md:hidden" onClick={fs.toggle} data-testid="menu-fullscreen">
          {fs.active ? <Minimize2 className="h-4 w-4 mr-2" /> : <Maximize2 className="h-4 w-4 mr-2" />}
          {fs.active ? t("Esci da schermo intero") : t("Schermo intero")}
        </DropdownMenuItem>
      )}
      <DropdownMenuSeparator className="md:hidden" />
    </>
  );
}
